import { ReplaySubject } from 'rxjs/ReplaySubject';
import { enLang, enCurrency } from 'interfaces/IProductData';
import { Observable } from 'rxjs/Observable';
import { translateService } from 'services/TranslateService';
import { paymentService } from './PaymentService';

export class LangService {
  private country$ = new ReplaySubject<any>(1);

  private countries = [
    { id: 'brasil', currency: enCurrency.BRL, lang: enLang.PT_BR, text: 'Brasil' },
    { id: 'unitedstates', currency: enCurrency.USD, lang: enLang.EN_US, text: 'United States' },
    { id: 'colombia', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Colombia' },
    { id: 'mexico', currency: enCurrency.USD, lang: enLang.EN_US, text: 'México' },
    { id: 'portugal', currency: enCurrency.USD, lang: enLang.PT_PT, text: 'Portugal' },
    { id: 'spain', currency: enCurrency.USD, lang: enLang.EN_US, text: 'España' },
    { id: 'argentina', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Argentina' },
    { id: 'peru', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Perú' },
    { id: 'chile', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Chile' },
    { id: 'ecuador', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Ecuador' },
    { id: 'other', currency: enCurrency.USD, lang: enLang.EN_US, text: 'Other' }
  ];

  constructor() {
    this.setLangByCountry('Brasil');
  }

  public setLang(lang: enLang) {
    let option = this.countries.find((c) => c.lang === lang);
    if (!option) {
      option = this.countries[0];
    }

    translateService.setLang(lang);

    this.country$.next(option);

    this.setPersonTypeByLang(lang);
  }

  public getLang(): Observable<enLang> {
    return this.country$
      .asObservable()
      .map((c) => c.lang)
      .distinctUntilChanged();
  }

  public getCountries() {
    return this.countries;
  }

  public getSelectedCountry() {
    return this.country$.asObservable();
  }

  public setLangByCountry(countryName: string) {
    const option = this.countries.find((c) => c.text === countryName);

    if (!option) {
      translateService.setLang(this.countries[0].lang);
      this.country$.next(this.countries[0]);
      return;
    }

    translateService.setLang(option.lang);
    this.setPersonTypeByLang(option.lang);
    this.country$.next(option);
  }

  private setPersonTypeByLang(lang: enLang) {
    if (lang === enLang.PT_BR) {
      paymentService.setData({ personType: 'F' });
    } else {
      paymentService.setData({ personType: 'E' });
    }
  }
}

// tslint:disable-next-line:variable-name
export const LangServiceFactory = () => new LangService();

export const langService = LangServiceFactory();
